// extracted by mini-css-extract-plugin
module.exports = {"disclosureContainer":"styles_disclosureContainer__imc7-","disclosure":"styles_disclosure__JoKz3","disclosureContent":"styles_disclosureContent__oeZYH"};